import { render } from "./AlterarSenhaModal.vue?vue&type=template&id=e033ec4e&scoped=true"
import script from "./AlterarSenhaModal.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaModal.vue?vue&type=script&lang=js"

import "./AlterarSenhaModal.vue?vue&type=style&index=0&id=e033ec4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e033ec4e"]])

export default __exports__